import request from "@/service";

/**
 * 获取所有行业类型
 * @param params
 * @returns {*}
 */
export function getIndustryTypeList(params) {
    return request({
        url: '/api/cms/getIndustryTypeList',
        method: 'get',
        params
    })
}

/**
 * 获取所有服务类型
 * @param params
 * @returns {*}
 */
export function getServeTypeList(params) {
    return request({
        url: '/api/cms/getServeTypeList',
        method: 'get',
        params
    })
}

/**
 * 获取所有案例数据
 * @param params
 * @returns {*}
 */
export function getCaseList(params) {
    return request({
        url: '/api/cms/getCaseList',
        method: 'get',
        params
    })
}

/**
 * 添加咨询记录
 * @param data
 * @returns {*}
 */
export function addConsultationRecord(data) {
    return request({
        url: '/api/cms/addConsultationRecord',
        method: 'post',
        data
    })
}
